//third party

import { NgModule } from "@angular/core";
import { PrimeNgAutoCompleteShadowdomFix } from "./primeng/autocomplete/shadowdom-fix/primeng.autocomplete.shadowdom-fix.directive";
import { PrimeNgCalendarShadowdomFix } from "./primeng/calendar/shadowdom-fix/primeng.calendar.shadowdom-fix.directive";
import { ValidatorsModule } from "./validators/validators.module";
import { ImageDirective } from "./img.directive";






@NgModule({
  exports: [
    ValidatorsModule,
    PrimeNgAutoCompleteShadowdomFix,
    PrimeNgCalendarShadowdomFix,
    ImageDirective
  ],
  declarations: [
    PrimeNgAutoCompleteShadowdomFix,
    PrimeNgCalendarShadowdomFix,
    ImageDirective
  ],
  imports: [
    ValidatorsModule
  ]
})
export class DirectivesModule { }
